import { Constants } from 'src/app/core/constants';
import { UserPermissions } from 'src/app/permissions';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { DueDateExtensionHistoryDTO } from 'src/app/models/duedateextensionhistory-dto';
import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import Helper from 'src/app/core/utility/helper';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BasePage } from '../../core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from '../../app.settings';
@Component({
  selector: 'app-duedateextension-history',
  templateUrl: './duedateextension-history.component.html',
  styleUrls: ['./duedateextension-history.component.scss']
})
export class DuedateextensionHistoryComponent extends BasePage implements OnInit {

  pendingProposalPartInfoData: PendingProposalPartInfo;

  minRevisedDueDate: Date;
  dueDateExtensionForm: FormGroup;
  public formErrors;
  ShowUpdateDDESection: boolean = false;
  ShowAdHocDDERequestSection: boolean = false;
  ShowAdHocDDERequestSectionHistory: boolean = false;
  filteredListForDDERequestHistory: DueDateExtensionHistoryDTO[];
  filteredListForAdhocDDERequestHistory: DueDateExtensionHistoryDTO[];

  constructor(
    private dialogRef: MatDialogRef<DuedateextensionHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public PendingProposalPartInfo: any,
    private fb: FormBuilder,
    private formService: FormService,
    private dataService: DataService,
    private toastService: ToastService,
    logger: NGXLogger,
    appSettings: AppSettings,
    localstorageService: LocalstorageService
  ) {
    super(localstorageService, logger, appSettings);
    this.pendingProposalPartInfoData = PendingProposalPartInfo;
  }

  ngOnInit() {
    // The minimum due date for extension is the exisitng due date.
    this.minRevisedDueDate = this.pendingProposalPartInfoData.DueDate;
    this.dueDateExtensionForm = this.fb.group({
      revisedDueDate: null
    });

    this.formErrors = {
      revisedDueDate: ''
    };
    // TMS-15782 Allowing user only with internal permission to extend due date
    //Commenting older logic and moved it to function 
    /*  const isSupplier = this.localstorageService.retrieve(Constants.localStorageKeys.IsSupplier);
        const hasReviewProposalWritePermission = Helper.CheckPermission(this.localstorageService, UserPermissions.Packaging_ReviewProposal_Write);
       this.ShowUpdateDDESection = isSupplier || hasReviewProposalWritePermission; */
    this.updateFlagstoShowDDRequestSections();
    this.showAdHocDDERequestHistory();
    this.filteredListForDDERequestHistory = this.pendingProposalPartInfoData.DueDateExtensionHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId == null);
  }

  formatDate(unformattedDate: Date) {
    return Helper.formatDate(unformattedDate);
  }

  validateForm() {
    Helper.resetFormErrors(this.formErrors);

    this.formErrors = this.formService.validateForm(
        <FormGroup>this.dueDateExtensionForm,
        this.formErrors
    );
  }

  submit() {
    this.saveDueDateExtension(this.pendingProposalPartInfoData);
    this.dialogRef.close();
  }

  /**
   * TMS-15768 save due date extension
   */
  saveDueDateExtension(pendingProposalPartInfo: PendingProposalPartInfo) {
    this.validateForm();
    if (this.dueDateExtensionForm.invalid) {
      return;
    }

    const dueDateExtension = new DueDateExtensionHistoryDTO();
    dueDateExtension.PendingProposalId = pendingProposalPartInfo.PendingProposalId;
    dueDateExtension.RevisedDueDate = this.dueDateExtensionForm.controls['revisedDueDate'].value;
    dueDateExtension.ShipDate = pendingProposalPartInfo.ShipDate;
    dueDateExtension.ExistingDueDate = pendingProposalPartInfo.DueDate;

    this.dataService.saveDueDateExtensionHistory(dueDateExtension)
        .subscribe((response: any) => {
            if (response &&
                response.Data &&
                response.Success) {
                pendingProposalPartInfo.DueDate = dueDateExtension.RevisedDueDate;
                this.toastService.success(
                    'Saved the due date extension for the pending proposal successfully.'
                );
            } else {
                this.toastService.error(
                    'Could not save the due date extension for the pending proposal.'
                );
            }
        });
  }

  //TMS-19723 Show DDERequestSection or AdHocDDERequestSection based on the logged in users
  updateFlagstoShowDDRequestSections() {
    // TMS-40395 Allow supplier to extend any no. of times so commenting earlier code
    this.ShowUpdateDDESection = true;
    // const isSupplier = this.localstorageService.retrieve(Constants.localStorageKeys.IsSupplier);
    // const hasReviewProposalWritePermission = Helper.CheckPermission(this.localstorageService, UserPermissions.Packaging_ReviewProposal_Write);

    // //FOR PE and Internal Users, always open DDE Request block 
    // if (hasReviewProposalWritePermission) {
    //   this.ShowUpdateDDESection = true;
    // }

    // /* For suppliers, if the requested extension exceeds above 3 then show Ad hoc request section to further request extension,
    //    otherwise show DDE request block */
    // else if (isSupplier) {
    //   if (this.pendingProposalPartInfoData.DueDateExtensionHistory.filter(x => x.IsByTeslaUser == false).length >= Constants.MaxNooftimesShipDateExtendedBySupplier) {
    //     this.ShowAdHocDDERequestSection = true;
    //   }
    //   else {
    //     this.ShowUpdateDDESection = true;
    //   }
    // }
  }

  showAdHocDDERequestHistory() {
    this.filteredListForAdhocDDERequestHistory = this.pendingProposalPartInfoData.DueDateExtensionHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId != null);
    if (this.filteredListForAdhocDDERequestHistory.length > 0) {
      this.ShowAdHocDDERequestSectionHistory = true;
    }
  }

  // get RequestStatus for Adhoc requests 
  getAdhocDDRequestStatus(statusId: any) {
    if (statusId == Constants.AdhocDDE_REQUESTED_STATUS_ID) {
      return Constants.AdhocDDE_STATUS_REQUESTED;
    }
    else if (statusId == Constants.AdhocDDE_APPROVED_STATUS_ID) {
      return Constants.AdhocDDE_STATUS_APPROVED;
    }
    else {
      return Constants.AdhocDDE_STATUS_REJECTED;
    }
  }
}
